<template>
    <div class="chart-info">
        <div class="chart-info__left">
            <div class="chart-info__row" v-for="(item,index) in dataItems" :key="index">
                <div @click="changeMainChart(item.chart)" :class="fullScreen ? 'chart-info__title chart-info__title--full' : 'chart-info__title'">{{item.title}} </div>
                <div :class="fullScreen ? 'chart-info__data chart-info__data--full' : 'chart-info__data'">
                    <watcher :data="item.data"
							 :units="getUnit"
							 :side="'left'"
				 	>
                    </watcher>
                </div>
                <i v-show="item.chartIcon" class="icon-profit chart-info__icon" @click ="changeMainChart(item.chart)"></i>
            </div>
            <div class="profitDeals" v-show="!mini">
                <div class="round-title">
                    <descr :text="'% Успешных сделок'"
                    :direction="'right'"></descr>
                </div>
                <round
                    :currency="symbol">
                </round>
            </div>
        </div>
        <div class="chart-info__right">
            <div v-show="switchMode" class="resetChartButton" @click="resetMaunChart">Общий график</div>
            <menuYear v-show="!switchMode" :years="uniqueYear" v-if="periodMenu"
            @changeYear = "setPeriod($event)"></menuYear>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import Watcher from "../../../ui-components/ui-data-watcher"
import menuYear from './sig-menu-change-year-profit-chart'
import roundChart from '../../../ui-components/persent-of-close-positions'
import Description from "../../../ui-components/description"
export default {
    data() {
        return {
            statistic:{},
            dataItems: [
                {
                    title:'ОБЩИЙ ДОХОД',
                    chart:'pointProfit',
                    data:0,
                    chartIcon:true
                },
                {
                    title:'МАКСИМАЛЬНЫЙ',
                    data:0,
                    chartIcon:false
                },
                {
                    title:'ЧИСТЫЙ ДОХОД ИНВЕСТОРА',
                    data:0,
                    chart:'pointInvest',
                    chartIcon:true
                },
                {
                    title:'СР. ГОДОВОЙ ДОХОД',
                    chart:'pointYearProfit',
                    data:0,
                    chartIcon:true,
                },
                {
                    title:'СР. ДОХОД В МЕСЯЦ',
                    data:0,
                    chart:'pointLine',
                    chartIcon:true
                },
                {
                    title:'% УСПЕШНЫХ МЕСЯЦЕВ',
                    data:0,
                    chart:'pointPositiveMonth',
                    chartIcon:true
                },
            ],
            indexChart:null,
            averragePercentInMonth:null,
            averragePercentInYear:null,
            investProfit:null,
            commonPercent:null,
            maxPersent:null,
            uniqueYear:[],
            year:null,
            profitMonth:0,
            showChart:false,
            dataForChart:0,
            pointsForCharts:0,
            titleForChart:'',
            switchMode:false
        }
    },
    components: {
        'watcher':Watcher,
        "menuYear":menuYear,
        "round":roundChart,
        'descr':Description
    },
    props: {
        symbol:{default:''},
        periodMenu:{default:true},
        type:{default:'percent'},
        fullScreen:{default:true},
        mini:{default:false}
    },
    computed: {
        ...mapGetters({
              getStatistics: 'accountstat/getMonthProfitStrategy'
        }),
        getUnit() {
            let unit = this.type === 'percent' ? '%' :'$';
            return unit;
        },
    },
    methods: {
        closePopupChart() {
            this.dataItems[this.indexChart].chartStatus = false;
        },
        changeMainChart(chartType) {
            this.switchMode = true;
            this.$emit('changeChart', chartType);
        },
        resetMaunChart() {
            this.switchMode = false;
            this.$emit('changeChart', null);
        },
        getData() {
            let stat = this.getStatistics(this.symbol);
            if (!stat)
                return;
            let data = {
                avInMonth:[],
                comPercent:[],
                investProfit:[]
            }
            let yearArr = [];
            let yearsPeriod = UnicYear(stat);
            this.uniqueYear = UnicYear(stat);
            if(this.year !== null) {
                for (let i = 0; i < stat.length; i++) {
                    if(stat[i].year === parseInt(this.year))
                        yearArr.push(stat[i])
                }
            } else
                yearArr = stat;
            for (let i = 0; i < yearArr.length; i++)
                data.avInMonth.push(sumTo(i,yearArr, this.type) / (i + 1));
            this.dataItems[4].data = data.avInMonth[data.avInMonth.length - 1];
            this.dataItems[5].data = getProfitMonth(yearArr);
            for(let i = 0; i < yearArr.length; i++) {
                if(i !== 0)
                    data.comPercent.push(sumTo(i,yearArr,this.type));
                    data.investProfit.push(sumToInvest(i,yearArr,this.type))
            }
            this.dataItems[0].data = data.comPercent[data.comPercent.length - 1];
            this.dataItems[2].data = data.investProfit[data.investProfit.length -1];
            this.dataItems[1].data = Math.max(...data.comPercent);
            let sumYearProfit = 0;
            let sumYearProfitArr = []
            if(this.year !== null) {
                let countYear = yearsPeriod.indexOf(this.year);
                yearsPeriod.splice(countYear + 1, yearsPeriod.length);
            }
            for(let i = 0; i < yearsPeriod.length; i++) {
                sumYearProfit+=sumToYear(stat,yearsPeriod[i],this.type);
                sumYearProfitArr.push({profit:sumToYear(stat,yearsPeriod[i],this.type)})
            }
            this.dataItems[3].data = (sumYearProfit/yearsPeriod.length);
        },
        setPeriod(year) {
            this.$emit('setYear', year);
            if(year === "Весь период")
                this.year = null;
            else
                this.year = year;
            this.getData();
        }
    },
    watch: {
        type: function() {
            this.getData();
        }
    },
    created() {
        subscribeOnUpdate(this.$store, this.symbol, isFirstObtained => {
            //if (!this.symbol || !this.symbol.length) {
                this.getData();
            //}
        });
        // может быть, данные уже есть в store
        this.getData();
    }
}
function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: symbol,
        callback: {
            id: `profit-sum-data-strategy-${symbol}`,
            handler: handler
        }
    });

}
function sumTo(n, array, type) {
  let sum = 0;
  if(type === 'percent') {
    for (let i = 0; i <= n; i++) {
        sum += array[i].profit;
    }
  } else {
    for (let i = 0; i <= n; i++) {
        sum += array[i].profitAbs;
    }
  }
  return sum;
}
function getProfitMonth(array) {
  let sum = 0;
    for (let i = 0; i < array.length; i++) {
        if(array[i].profit > 0)
            sum ++;
    }
    let profitMonth = 100/(array.length/sum);
  return profitMonth;
}
function sumToYear(stat, year, type) {
  let sum = 0;
  if(type === 'percent') {
    for (let i = 0; i < stat.length; i++) {
        if(stat[i].year === parseInt(year))
            sum += stat[i].profit;
    }
  } else {
     for (let i = 0; i < stat.length; i++) {
        if(stat[i].year === parseInt(year))
            sum += stat[i].profitAbs;
    }
  }
  return sum;
}
function UnicYear(stat) {
  let sum = {};
  for (let i = 0; i < stat.length; i++) {
        let str = stat[i].year
        sum[str] = true;
  }
  return Object.keys(sum);
}

function sumToInvest(n, array, type) {
    let sum = 0;
    let maxProfit = 0
    if(type === 'percent')
        maxProfit = array[0].profit;
    else
        maxProfit = array[0].profitAbs;
    if(type === 'percent') {
    for (let i = 0; i <= n; i++) {
        if(array[i].profit > maxProfit) {
            maxProfit = array[i].profit;
            sum += array[i].profit - array[i].profit * 0.363;
        }
        else if(array[i].profit > 0)
            sum += array[i].profit - array[i].profit * 0.03;
        else if(array[i].profit < 0)
            sum += array[i].profit + array[i].profit * 0.03;
    }
  } else {
    for (let i = 0; i <= n; i++) {
        if(array[i].profitAbs > maxProfit) {
            maxProfit = array[i].profitAbs;
            sum += array[i].profitAbs - array[i].profitAbs * 0.363;
        }
        else  if(array[i].profitAbs > 0)
            sum += array[i].profitAbs - array[i].profitAbs * 0.03;
        else if(array[i].profitAbs < 0)
            sum += array[i].profitAbs + array[i].profitAbs * 0.03;
    }
  }
  return sum;
}
</script>
<style lang="less" scoped>
.resetChartButton {
    font-family: Arimo;
    font-size: 14px;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    margin-right: 0px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 145px;
    height: 40px;
    box-sizing: border-box;
    padding: 0px 8px 0px 8px;
    color: #374b62;
    background: #00ffd0;
    cursor: pointer;
}

.round-title {
    font-family: Arimo;
    font-size: 18px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1;
    letter-spacing: 0.4px;
    color: #aabed2;
    text-transform: uppercase;
    margin-right: 4px;
    margin-bottom: -18px;
}
.profitDeals {
    width: 150px;
    margin-top: 18px;

    @media (max-width: 1600px) {
        width: 100px;
    }
}
.chartPopup {
    min-width: 100%;
    min-height: 100%;
    position: absolute;
    background: rgba(0,0,0,0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    top:0;
    right: 0;
}

</style>
